exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*.el-table__fixed, .el-table__fixed-right {*/\n    /*pointer-events: none;*/\n/*}*/\n/*.el-table__fixed, .el-table__fixed-right > .td {*/\n    /*pointer-events: none;*/\n/*}*/\n/*.el-table__fixed > * {*/\n    /*pointer-events: all;*/\n/*}*/\n\n/*.el-form-item__content {*/\n    /*pointer-events: all;*/\n/*}*/\n", ""]);

// exports
